/* eslint-disable no-empty-label,no-mixed-spaces-and-tabs */
import Vue from 'vue'
import Router from 'vue-router'
import constRoutes from './constRoutes'
import store from '../store'

Vue.use(Router)
//几个允许自己访问的页面
const pubRouter = ['/login', '/account/password_change', '/account/outsource_register']
//layout为通配模板页面
const router = new Router({
  routes: constRoutes
})
function handleReject(next) {
  if (store.getters.hasSettingRoutes) {
    store.dispatch('InvalidToken')
    next('/login')
  } else {
    store.dispatch('ReplaceLogin')
    next('/login')
  }
}

router.beforeEach((to, from, next) => {
  //切换路由先回判断 vuex里面或者缓存 里面有没有token
  if (store.getters.token) {
    // 判断是否有token
    if (pubRouter.includes(to.path)) {
      next('/')
    } else {
      //判断用户是否已经加载过权限
      if (!store.getters.hasSettingRoutes) {
        store
          .dispatch('RequireUserInfo')
          .then((res) => {
            store
              .dispatch('InitRoutes', { type: res.type })
              .then((accessedRoutes) => {
                //初始化  tag
                store.dispatch('initTags')
                router.addRoutes(accessedRoutes)
                next({ ...to, replace: true })
              })
              .catch(() => {
                handleReject(next)
              })
          })
          .catch(() => {
            handleReject(next)
          })
      } else {
        document.title = to.meta && to.meta.title ? to.meta.title : store.getters.appTitle
        next() //当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
      }
    }
  } else if (pubRouter.includes(to.path)) {
    document.title = to.meta && to.meta.title ? to.meta.title : store.getters.appTitle
    next()
  } else {
    next({
      path: '/login'
    }) // 否则全部重定向到登录页
  }
})

//get router新增方法是不是不太好？
router.changeState = function(path, query, isReplace) {
  if (!path || typeof path !== 'string') {
    throw new Error('router pushState path must be string')
  }
  query = query || {}
  let querySearch = Object.keys(query)
    .map((keys) => `${keys}=${query[keys]}&`)
    .join('')
    .replace(/&*$/g, '')

  if (router.mode === 'hash') {
    isReplace
      ? history.replaceState(null, null, `/#${path}?${querySearch}`)
      : history.pushState(null, null, `/#${path}?${querySearch}`)
  } else {
    isReplace
      ? history.replaceState(null, null, `${path}?${querySearch}`)
      : history.pushState(null, null, `${path}?${querySearch}`)
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js